// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobilePagination{display:flex;justify-content:center;margin:12px auto 10px auto;padding:8px 0 10px}.MobilePagination>ul{align-items:center;display:flex;flex-wrap:nowrap;height:31px;margin:0;padding:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
